import React from 'react';
import { FaCcPaypal, FaPaypal,  FaGooglePay,  FaCcApplePay, FaCcMastercard, FaCcDiscover  } from "react-icons/fa6";
import { RiVisaFill } from "react-icons/ri";

import { SiCashapp, SiAmericanexpress  } from "react-icons/si";




import '../Styles/Footer.css'
import SignUp from '../pages/SignUp';


export default function Footer ()  {
    const mCard = { color: "crimson", fontSize:"4.5em" };
    const dCard = { color: "darkred", fontSize:"4.5em" };
    const vCard = { color: "silver", fontSize:"4.5em" };
    const aCard = { color: "darkblue", fontSize:"4em" };
    const gPay = { color: "blue", fontSize:"4.5em" };
    const aPay = {  fontSize:"4.3em" };
    const cash = { color: 'green', fontSize:"1.5em" };
    const paypal = { color: 'cornflowerblue', fontSize:"3.5em" };
    const payP = { color: 'navy', fontSize:"3.5em" };
   

   
     


  return (
    <div>
          <div className='payments-accepted container-fluid '>
                <h4 className='payment-header pt-4'>Payments Accepted</h4>
            <ul className="list-group list-group-horizontal text-center d-flex">
            <li className="list-group-item flex-fill align-items-center pay-pal"><FaPaypal style={payP} /> <FaCcPaypal style={paypal} /></li>
            <li className="list-group-item flex-fill cash-app align-items-center"> Cash App <SiCashapp style={cash} /> </li>
            <li className="list-group-item flex-fill g-pay align-items-center"><FaGooglePay style={gPay} /> < FaCcApplePay style={aPay} /></li>
            <li className="list-group-item flex-fill align-items-center cc-cards"><FaCcMastercard style={mCard} /> <RiVisaFill style={vCard} /> <FaCcDiscover  style={dCard} />   <SiAmericanexpress style={aCard} />  </li>
            </ul>

            </div>

        <div className='lower-footer container-fluid'>

        <div className="container text-center">
            <div className="row row-cols-3">
                <div className="col">Help & Info

                </div>
                <div className="col">
                    <div className='contact'>
                    Contact
                    </div>
                    <div className='contact-email'>
                          marshmallowmooncouture@gmail.com
                        <div className='form-contact'>
                           
                        </div>
                    </div>
                    </div>


                <div className="col">
                  
                    <SignUp />
                </div>
               
            </div>
            </div>


        </div>

    </div>
  )
}


